import React from "react";
import PropTypes from "prop-types";
import Navigation from "../../../views/navigation/containers/navigation";
import PrivacyTos from "../../privacy-policy-tos";
import Spinner from "./spinner";
import { getMainContentContainerClasses } from "../../../utils/style-helper";
import eventType from "../../../prop-types/eventType";
import "../styles/template.scss";

const propTypes = {
  types: PropTypes.arrayOf(eventType).isRequired,
  tabName: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]).isRequired,
  header: PropTypes.string,
  isLoading: PropTypes.bool,
  fullHeight: PropTypes.bool,
  fullWidth: PropTypes.bool
};

const defaultProps = {
  header: "",
  isLoading: false,
  fullHeight: false,
  fullWidth: false
};

function Template(props) {
  const { header, tabName, types, isLoading, fullHeight, fullWidth, children } =
    props;

  return (
    <div
      role="region"
      className="main-content-area d-flex flex-column container-fluid"
    >
      {types && !!types.length && (
        <Navigation tabName={tabName} types={types} />
      )}
      {header && <h1>{header}</h1>}
      {isLoading && (
        <div className={getMainContentContainerClasses(true, true)}>
          <Spinner />
        </div>
      )}
      {!isLoading && (
        <div className={getMainContentContainerClasses(fullHeight, fullWidth)}>
          {children}
        </div>
      )}
      <PrivacyTos />
    </div>
  );
}

Template.propTypes = propTypes;
Template.defaultProps = defaultProps;

export default Template;
